import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"search\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.219 12.066C10.27 12.692 9.22 13 8 13a6 6 0 116-6c0 1.731-.66 3.225-1.833 4.32l3.654 3.653a.6.6 0 01-.848.848l-3.754-3.755zM8 12A5 5 0 108 2a5 5 0 000 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol